var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRightMark = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "102px",
    viewBox: "0 0 102 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "247191AF-49A2-48EA-9E11-0180A09A1A68") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "36-Sixtbook_directly_to_Queston_for,m",
    transform: "translate(-799.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(545.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(255.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_check",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "0 0 71.2997347 0 71.2997347 78.4533985 0 78.4533985"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#191919",
    strokeWidth: 2,
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#191919",
    strokeWidth: 2,
    points: "23 52.6581876 39.26 69 39.26 69 77 31"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRightMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_rightMark.20b93b7ef96be53289c1736dd418b78b.svg";